import { Badge, IconButton, Tooltip, useToast } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { MdNotifications } from "react-icons/md";
import { Optional } from "../../components/Form";
import {
  AccountRole,
  CallStatus,
  useSendRetryCallNotificationMutation,
} from "../../graphql";
import { useAuthToken } from "../../hooks";

const SendRetryCallNotification: React.FC<{
  callId: number;
}> = ({ callId }) => {
  const [send, { loading }] = useSendRetryCallNotificationMutation();
  const toast = useToast();
  const { role } = useAuthToken();

  return (
    <Tooltip label={"Dërgo njoftimin 'Linjë e lirë'"}>
      <IconButton
        ml={2}
        variant="ghost"
        size="sm"
        colorScheme="orange"
        aria-label="Retry call notification"
        icon={<MdNotifications />}
        isLoading={loading}
        isDisabled={
          !(
            role === AccountRole.Doctor ||
            role === AccountRole.MedicalSpecialist
          )
        }
        onClick={async (ev) => {
          ev.preventDefault();
          ev.stopPropagation();

          await send({
            variables: {
              callId: callId,
            },
          });

          toast({
            status: "success",
            title: "Sukses",
            description: "Njoftimi u dërgua me sukses",
          });
        }}
      />
    </Tooltip>
  );
};

export const GetCallStatus: React.FC<{
  call: { startTime?: Date; status: CallStatus; id: number };
}> = ({ call }) => {
  const { t } = useTranslation();
  const status = call.status;

  if (status === CallStatus.Expired) {
    return (
      <>
        <Badge colorScheme="red">{t("calls.statusList.lost")}</Badge>
        <SendRetryCallNotification callId={call.id} />
      </>
    );
  }

  if (status === CallStatus.Ringing) {
    return <Badge>{t("calls.statusList.ringing")}</Badge>;
  }

  if (status === CallStatus.Started) {
    return <Badge>{t("calls.statusList.started")}</Badge>;
  }

  if (status === CallStatus.Terminated && !call.startTime) {
    return <Badge colorScheme="red">{t("calls.statusList.terminated")}</Badge>;
  }

  if (status === CallStatus.Terminated) {
    return <Badge colorScheme="green">{t("calls.statusList.completed")}</Badge>;
  }

  if (status === CallStatus.Waiting) {
    return <Badge>{t("calls.statusList.waiting")}</Badge>;
  }
};
